import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
Vue.config.productionTip = false;
import "@/assets/styles/utils.scss";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

// 富文本编辑器
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(VueQuillEditor);

// 视频播放器
import Video from "video.js";
import "video.js/dist/video-js.css";

import * as echarts from "echarts";
import 'echarts/lib/chart/bar'

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
